module.exports = __webpack_public_path__ + "img/me.552b6899.png";